import { useState } from 'react'

export default function PassBar({ passes }) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed || !passes || passes.length === 0) return null

  const scrollToPasses = () =>
    document.getElementById('passes')?.scrollIntoView({ behavior: 'smooth' })

  return (
    <>
      <style>{`
        @keyframes passbar-slide-down {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .passbar-min {
          animation: passbar-slide-down 1.1s cubic-bezier(0.16, 1, 0.3, 1) both;
        }
        .passbar-min-inner {
          display: flex; justify-content: space-between; align-items: center;
          gap: 16px; padding: 14px clamp(24px,5vw,56px); flex-wrap: wrap;
        }
        @keyframes underline-pulse {
          0%, 100% { opacity: 0.35; }
          50% { opacity: 1; }
        }
        .passbar-link {
          position: relative;
          text-decoration: none;
        }
        .passbar-link::after {
          content: '';
          position: absolute;
          bottom: -3px; left: 0; right: 0;
          height: 1px;
          background: #f5f1e8;
          animation: underline-pulse 2s ease-in-out infinite;
        }
      `}</style>
      <div className="passbar-min" style={{
        position: 'relative',
        zIndex: 90,
        background: '#0a0a0a',
        marginBottom: 40,
        borderRadius: 3,
      }}>
        <div className="passbar-min-inner">
          <div style={{ fontFamily: 'var(--f-b)', fontSize: 13, fontWeight: 400, color: '#f5f1e8' }}>
            Save up to <strong style={{ fontWeight: 500 }}>£30</strong> with a class pass — valid 6 months.
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
            <button onClick={scrollToPasses} className="passbar-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--f-b)', fontSize: 13, fontWeight: 500, color: '#f5f1e8', padding: 0, whiteSpace: 'nowrap' }}>
              View passes →
            </button>
            <button onClick={() => setDismissed(true)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.4)', fontSize: 15, padding: 4, lineHeight: 1, flexShrink: 0 }}>
              ✕
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
